// src/store/api/parentApiSlice.js
import { apiSlice } from "./apiSlice";

export const parentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// Get all parent DTOs (without passwords)
		getAllParentDtos: builder.query({
			query: () => "/Parent",
			providesTags: ["Parents"],
		}),

		// Get parent DTO by ID
		getParentDtoById: builder.query({
			query: (id) => `/Parent/${id}`,
			providesTags: (result, error, id) => [{ type: "Parents", id }],
		}),

		// Create parent
		createParent: builder.mutation({
			query: (parentData) => ({
				url: "/Parent",
				method: "POST",
				body: parentData,
			}),
			invalidatesTags: ["Parents"],
		}),

		// Update parent
		updateParent: builder.mutation({
			query: ({ id, ...parentData }) => ({
				url: `/Parent/${id}`,
				method: "PUT",
				body: parentData,
			}),
			invalidatesTags: (result, error, { id }) => [
				"Parents",
				{ type: "Parents", id },
			],
		}),

		// Delete parent
		deleteParent: builder.mutation({
			query: (id) => ({
				url: `/Parent/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["Parents"],
		}),
	}),
});

export const {
	useGetAllParentDtosQuery,
	useGetParentDtoByIdQuery,
	useCreateParentMutation,
	useUpdateParentMutation,
	useDeleteParentMutation,
} = parentApiSlice;
